import UsersContainer from './UsersContainer';
export default UsersContainer;
